<template>

    <div>
        <div class="container-fluid mb-2" v-show="editEnabled">
            <div class="d-flex justify-content-between align-items-center" style="position: relative;">
                <label class="pt-4">Type</label>
                <button type="button" class="delete-btn" v-on:click="$emit('handleDelete', courseDetails, config)" v-if="editEnabled"><i class="fa fa-trash-o"></i></button>
            </div>
            <select v-model="config.type" @change="handleChange(null, null, '')">
                <option value="CourseName">Course Name</option>
                <option value="StudentName" v-if="showOption('StudentName')">Student Name</option>
                <option value="BackgroundImage">Background Image</option>
                <option value="CompletionDate" v-if="showOption('CompletionDate')">Completion Date</option>
                <option value="AttendeeName" v-if="showOption('AttendeeName')">Attendee Name and Surname</option>
                <option value="AttendeeCompany" v-if="showOption('AttendeeCompany')">Attendee Company</option>
                <option value="AttendeeFacilitySite" v-if="showOption('AttendeeFacilitySite')">Attendee Facility / Site</option>
                <option value="AttendeeIdNumber" v-if="showOption('AttendeeIdNumber')">Attendee ID / Passport</option>
                <!-- passport merged into ID / Passport; only shown on fields saved with the old type -->
                <option value="AttendeePassport" v-if="config.type == 'AttendeePassport'">Attendee ID / Passport (old)</option>
                <option value="AttendeeEmployeeId" v-if="showOption('AttendeeEmployeeId')">Attendee Employee ID Number</option>
                <option value="AttendeeDate" v-if="showOption('AttendeeDate')">Attendee Attendance Date</option>
                <option value="AttendeeFacilitator" v-if="showOption('AttendeeFacilitator')">Facilitator Name</option>
                <!--custom certificate property-->
                <option value="Custom">Custom</option>
            </select>
        </div>
        <div v-if="config.type == 'Custom'" class="d-flex">
            <div class="container-fluid">
                <label>Custom Property</label>
                <select v-model="config.customType">
                    <option value="image">Image</option>
                    <option value="text">Text</option>
                    <option value="idNumber" v-if="!facilitated || config.customType == 'idNumber'">ID Number</option>
                </select>
                <div v-if="config.customType == 'image'" class="row">
                    <div class="col-6 d-flex">
                        <label>Image filename</label>
                        <p class="ml-2">{{ config.imageFileName }}</p>
                    </div>
                    <div class="col-6">
                        <input @change="handleChange( $event.target, config, 'image')" type="file" />
                    </div>
                </div>
                <div v-if="config.customType == 'text'" class="mt-2">
                    <input v-on:keyup="handleChange(null, null, '')" type="text" v-model="config.customText" placeholder="Enter text" />
                </div>
                <div v-if="config.customType == 'idNumber'" class="mt-2">
                    <input type="hidden" v-model="config.customText"/>
                </div>
            </div>
        </div>
        <div v-if="config.type == 'BackgroundImage'" class="d-flex">
            <div class="container-fluid">
                <label>Image filename</label>
                <input @change="handleChange( $event.target, config, '')" type="file" />
            </div>
        </div>
        <div v-if="editEnabled && config.type != 'BackgroundImage'" class="p-2">
            <div class="row">
                <div class="col-8">
                    <div class="title">
                        {{config.type}}
                    </div>
                </div>
                <div class="col-4 d-flex align-items-center">
                    <input v-model="config.centerHorizontally" type="checkbox" @change="handleChange(null, null, '')" />
                    <label class="ml-2 mb-0">Center in page</label>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Font Size</label>
                    <input v-model.number="config.fontSize" type="number" @input="handleChange(null, null, '')" />
                </div>
                <div class="col">
                    <label>Position X</label>
                    <input v-model.number="config.x" type="number" @input="handleChange(null, null, '')" />
                </div>
                <div class="col">
                    <label>Position Y</label>
                    <input v-model.number="config.y" type="number" @input="handleChange(null, null, '')" />
                </div>
                <div class="col" v-if="config.customType == 'image'">
                    <label>Width</label>
                    <input v-model.number="config.width" type="number" v-on:keyup="handleChange(null, null, '')" />
                </div>
                <div class="col" v-if="config.customType == 'image'">
                    <label>Height</label>
                    <input v-model.number="config.height" type="number" v-on:keyup="handleChange(null, null, '')" />
                </div>
            </div>
            <label>Color (Hex)</label>
            <input v-model="config.colorHex" type="text" />
            <div class="row">
                <div class="col-6 d-flex">
                    <label>Font filename</label>
                    <p class="ml-2">{{ config.fileName }}</p>
                </div>
                <div class="col-6">
                    <input @change="handleChange($event.target, config, '')" type="file" />
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
    .delete-btn {
        position: absolute;
        right: 5px;
        padding: 0;
        color: red;
        background-color: transparent;
        border: none;
    }

        .delete-btn:hover {
            transform: scale(1.1);
            cursor: pointer;
        }
</style>

<script>
    export default {
        name: "CertificateProperty",
        props: ["initialConfig", "edit", "initialCourseDetails", "facilitated"],
        data() {
            return {
                config: this.initialConfig,
                editEnabled: this.edit,
                courseDetails: this.initialCourseDetails,
            }
        },
        watch: {
            initialConfig: function (newVal, oldaVal) {
                this.$emit("updatePreview");
                this.config = newVal;
            },
            edit: function (newVal, oldaVal) {
                this.editEnabled = edit;
            },
            initialCourseDetails: function (newVal, oldVal) {
                this.courseDetails = newVal;
            },
        },
        methods: {
            // attendee fields only on facilitated courses, student fields only on the rest; the field's current type always stays visible
            showOption(type) {
                return type == this.config.type || type.startsWith("Attendee") == !!this.facilitated;
            },
            async handleChange(target, config, type) {
                if (target && config) {
                    this.$emit('handleFileChange', target, config, type);
                }
                this.$emit("updatePreview");
            }

        },
        mounted() {
            //console.log("Certificate property mounted");
        }
    }
</script>